module.exports = __webpack_public_path__ + "static/media/account.fe6507b6.svg";